export const FULL_DATE_FORMAT: Intl.DateTimeFormatOptions = {
  month: 'short',
  day: 'numeric',
  year: 'numeric',
  hour: 'numeric',
  minute: 'numeric',
}

export const SIMPLE_DATE_FORMAT: Intl.DateTimeFormatOptions = {
  month: 'short',
  day: 'numeric',
  year: 'numeric',
}

export const SHORT_DATE_FORMAT: Intl.DateTimeFormatOptions = {
  month: 'numeric',
  day: 'numeric',
  year: 'numeric',
}

export const DEFAULT_PAGE = 1
export const PAGE_SIZE = 10

export const STATUS_COLORS = {
  PAID: 'success',
  PAID_ON_PAYPAL: 'success',
  REPORTED_NEGATIVE_AMOUNT: 'danger',
  PENDING: 'warning',
  FAILED: 'danger',
}
